import React from "react";
import { Field } from "react-final-form";
import FormDropdown from "../FormDropdown/FormDropdown";

const FormDropdownField = ({ name, label, options, disabled = false }) => {
  return (
    <Field name={name} disable={disabled}>
      {({ input, meta }) => (
        <div className="form-group">
          <FormDropdown label={label} options={options} selectedValue={input.value} onChange={input.onChange} />
          {meta.error && <span className="required-field-error">{meta.error}</span>}
        </div>
      )}
    </Field>
  );
};

export default FormDropdownField;
